import LoadingOrValue from "@covertree/ui/loading/LoadingOrValue";
import { Resident } from "@graphql/api";
import InsuranceAdoptionStatusText from "../../../../../../InsuranceAdoptionStatusText";
import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";

interface Props {
  isLoading?: boolean;
  resident?: Resident;
}

export default function InsuranceAdoptionDetails({
  isLoading,
  resident,
}: Props) {
  const status = resident?.insuranceAdoption.status;

  return (
    <>
      <DisplayPropertiesCard
        properties={[
          {
            label: "Insurance Adoption Status",
            gridSize: 4,
            value: (
              <InsuranceAdoptionStatusText
                component="span"
                isLoading={isLoading}
                status={status}
              />
            ),
          },
          {
            label: "Description",
            gridSize: 8,
            value: (
              <LoadingOrValue
                loading={
                  resident?.insuranceAdoption?.description === undefined &&
                  isLoading
                }
                value={resident?.insuranceAdoption?.description}
                height={28}
                width={130}
              />
            ),
          },
        ]}
      />
    </>
  );
}
